import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    background: theme.palette.colors.white,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1,
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  root: {
    color: theme.palette.colors.teal,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/Loader/useStyles.js